<div class="coseguros-container">

    <div class="coseguros-card" *ngIf="!loading; else loadingTemplate">

        <div class="card-header">
            <div class="header-icon-circle">
                <span class="material-icons">medical_services</span>
            </div>
            <h1>Coseguros</h1>
        </div>

        <ng-container *ngIf="sinDatosGecros; else contenidoNormal">

            <div class="leyenda-box">
                <span class="material-icons leyenda-icon">error_outline</span>
                <p>No se encontraron datos en GECROS para su documento. Comuniquese con administracion.</p>
            </div>

        </ng-container>

        <ng-template #contenidoNormal>

        <ng-container *ngIf="titular && signoPlan; else sinPlanTemplate">

            <div class="info-section">
                <div class="info-row">
                    <span class="info-label">Titular</span>
                    <span class="info-value">{{ titular.nombrePersona }} {{ titular.apellidoPersona }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Plan</span>
                    <span class="info-value plan-badge">{{ signoPlan.denominacion }}</span>
                </div>
            </div>

            <div class="content-section" *ngIf="signoPlan.activoDescarga && pdfUrl; else leyendaTemplate">
                <div class="pdf-wrapper" (contextmenu)="$event.preventDefault()">
                    <iframe
                        [src]="pdfUrl | safeResourceUrl"
                        class="pdf-viewer"
                        title="Documento del plan"
                        (load)="onPdfLoad()"
                    ></iframe>
                </div>
            </div>

            <ng-template #leyendaTemplate>
                <div class="leyenda-box">
                    <span class="material-icons leyenda-icon">info</span>
                    <p>{{ signoPlan.leyendaUsuario || leyendaDefault }}</p>
                </div>
            </ng-template>

        </ng-container>

        <ng-template #sinPlanTemplate>
            <div class="leyenda-box">
                <span class="material-icons leyenda-icon">warning</span>
                <p>No tenes un plan asociado. Contacta con soporte para mas informacion.</p>
            </div>
        </ng-template>

        </ng-template>

    </div>

    <ng-template #loadingTemplate>
        <div class="loading-spinner">
            <mat-spinner diameter="48" color="accent"></mat-spinner>
            <p>Cargando informacion del plan...</p>
        </div>
    </ng-template>

</div>
